/* The set (.bnd) on the v3 pages: pack shots arrive with different amounts of empty space around the
   product, so the same CSS height gives three different product sizes. This reads each image once,
   finds the product's own bounding box, and scales/centres it so every product stands the same height.
   Fails silently (image left as CSS sized it) if the pixels cannot be read. */
(function(){
  function fit(img){
    try{
      if(!img.naturalWidth) return;
      var S=96,c=document.createElement('canvas'); c.width=c.height=S;
      var x=c.getContext('2d',{willReadFrequently:true}); x.drawImage(img,0,0,S,S);
      var d=x.getImageData(0,0,S,S).data, b=[d[0],d[1],d[2],d[3]], x0=S,y0=S,x1=-1,y1=-1;
      for(var y=0;y<S;y++) for(var X=0;X<S;X++){
        var i=(y*S+X)*4; if(d[i+3]<24) continue;
        if(b[3]>24 && Math.abs(d[i]-b[0])+Math.abs(d[i+1]-b[1])+Math.abs(d[i+2]-b[2])<40) continue;
        if(X<x0)x0=X; if(X>x1)x1=X; if(y<y0)y0=y; if(y>y1)y1=y;
      }
      if(x1<0) return;
      var w=(x1-x0+1)/S, h=(y1-y0+1)/S, cx=(x0+x1+1)/2/S, cy=(y0+y1+1)/2/S;
      var fig=img.parentNode, iw=img.clientWidth||1, ih=img.clientHeight||1;
      /* wide figure (desktop cards): the product stands 76% of the figure's height.
         narrow figure (phone rows, ~112px): every product stands the same 86px, however tall the row is. */
      var narrow=fig.clientWidth<200, tH=narrow?86:.76*fig.clientHeight, wMax=(narrow?.86:.62)*fig.clientWidth;
      var s=Math.min(tH/(h*ih), wMax/(w*iw), 3);
      img.style.setProperty('--fit','translate('+(-(cx-.5)*100*s).toFixed(2)+'%,'+(-(cy-.5)*100*s).toFixed(2)+'%) scale('+s.toFixed(3)+')');
    }catch(e){}
  }
  function all(){ [].forEach.call(document.querySelectorAll('.bnd-card figure img'),function(img){
    if(!img.__fit){ img.__fit=1; img.addEventListener('load',function(){fit(img)}); }
    if(img.complete) fit(img);
  }); }
  if(document.readyState!=='loading') all(); else document.addEventListener('DOMContentLoaded',all);
  window.addEventListener('load',all); window.addEventListener('resize',function(){clearTimeout(all.t); all.t=setTimeout(all,150)});
})();
